"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CORSRules_1 = require("./_CORSRules");
exports.GetBucketCorsOutput = {
    type: "structure",
    required: [],
    members: {
        CORSRules: {
            shape: _CORSRules_1._CORSRules,
            locationName: "CORSRule"
        }
    }
};
//# sourceMappingURL=GetBucketCorsOutput.js.map